import type { ReactNode } from "react";

/**
 * Daily Brief — its own top-level section, kept SEPARATE from Market Timing.
 *
 * The page lived at `/timing/daily-brief` and so inherited that section's
 * sub-tab bar. Once it was promoted out of the Market Timing tab list, the bar
 * was still rendered above it by `app/timing/layout.tsx` — a row of nine
 * siblings it is no longer one of, with none of them active. Same shape, and
 * the same fix, as Live Breadth: move the route out, leave a redirect behind.
 *
 * Single page, so no sub-tab bar of its own.
 */
export default function DailyBriefLayout({ children }: { children: ReactNode }) {
  return (
    <main className="legacy-light w-full px-6 py-2 xl:px-8 2xl:px-10">
      {children}
    </main>
  );
}
